import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { trackPageview } from 'utils/analytics';

// Sends one page view per route change (see utils/analytics).
const PageviewTracker = () => {
  const location = useLocation();
  const role = useSelector((state) => state.auth?.user?.role);

  useEffect(() => {
    trackPageview(location, { role });
    // Only a new path is a new page; role changes on login aren't one.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};

export default PageviewTracker;
